<form action="" [formGroup]="form">
    <mat-form-field appearance="outline" [ngClass]="!isRequired ? 'hide-error' :''" >
        <mat-label>{{ label | translate }}</mat-label>
        <input
            type="text"
            aria-label="auto complete"
            matInput
            formControlName="Id"
            [matAutocomplete]="autoServices"
            (input)="onType(autocompleteServices.value)"
            #autocompleteServices
        />
        <mat-autocomplete
            #autoServices="matAutocomplete"
            [displayWith]="displayFn.bind(this)"
        >
            <mat-option [value]="''" (click)="changeSelected($event)">
                {{'Common.Choose'|translate}}
            </mat-option>
            <ng-container *ngFor="let item of dataSource">
              <mat-option [value]="item" (click)="changeSelected($event)">
                {{item.User.UserFullName}}
              </mat-option>
              <mat-divider class="chart-divider"></mat-divider>
            </ng-container>
        </mat-autocomplete>
    
        <mat-error *ngIf="form.get('Id')?.errors?.['required']">
            {{ 'Common.RequiredField' | translate }}
        </mat-error>
        <mat-error *ngIf=" this.form.get('Id')?.errors?.['autoCompleteRequired']">
            {{ 'Common.ChooseFromListReq' | translate }}
        </mat-error>
    </mat-form-field>
</form>